import React, { useState, useEffect, useRef } from 'react';
import ReactToolTip from 'react-tooltip';
import $, { data } from 'jquery';
import LeftNav from '../common/leftnav/leftnav';
import HeaderTop from '../common/headerTop/headerTop';
import { ResourceService } from '../../services/resource.service';
import RegionService from '../../services/region.service';
import CommonMessage from '../common/commonMessage';
import { Redirect, useHistory } from 'react-router-dom';
import LoadBalancerService from './loadbalancerapis';
import { NetworkService } from '../../services/network.service';
import ServerService from '../../services/server.service';
import { axiosInstance } from '../../constants/server.constant';
import { API_HOST, axiosRequestWithAuth } from './../../constants/server.constant';
import Validate from '../common/validate';
export default function ManageLoadBalancer(props) {


    const maxRetriesDownRef = useRef();
    const maxRetiresRef = useRef();
    const timeoutRef = useRef();
    const delayRef = useRef();
    const expectedCodesRef = useRef();
    const urlRef = useRef();
    const cookieRef = useRef();

    const [isAction, setIsAction] = useState(false);
    const [loadBalData, setLoadBalData] = useState(props.location.state.loadBalData);
    const [isCCAdded, setIsCCAdded] = useState(false);
    const [isUserSubscribed, setIsUserSubscribed] = useState(false);
    const [isTypeNotHttpOrHttps, setIsTypeNotHttpOrHttps] = useState(false);
    const [message, setMessage] = useState('');
    const [msgType, setMsgType] = useState('');

    const [errSrc, setErrSrc] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [algorithmList, setAlgoList] = useState([]);
    const [sessionTypes, setSessionTypes] = useState([]);
    const [protocols, setProtocols] = useState([]);
    const [healthChecks, setHealthChecks] = useState([]);
    const [httpMethods, setHttpMethods] = useState([]);
    const [expectedCodes, setExpectedCodes] = useState([]);
    const [ecodesError, setEcodesError] = useState(false);
    const [ecodesErrorMsg, setEcodesErrorMsg] = useState("");
    const [filterECodes, setFilterECodes] = useState([]);
    const [healthChecksSelectedECodes, setHealthChecksSelectedECodes] = useState([]);
    const [healthChecksUrl, setHealthChecksUrl] = useState([]);
    const [instanceList, setInstanceList] = useState([]);
    const [lbName, setLbName] = useState("");
    const [lbOldName, setLbOldName] = useState("");
    const [regionName, setRegionName] = useState('LA2');
    const [regionUrl, setRegionUrl] = useState("");
    const [attachedInstance, setAttachedInstance] = useState([]);
    const [filteredIns, setFilteredIns] = useState([]);
    const [loadBalConfigLabel, setLoadBalConfigLabel] = useState("");
    const [loadBalConfigAlgo, setLoadBalConfigAlgo] = useState("");
    const [loadBalConfigSession, setLoadBalConfigSession] = useState("");
    const [loadBalConfigCookie, setLoadBalConfigCookie] = useState("");
    const [port, setPort] = useState("");
    const [protocol, setProtocol] = useState("");
    const [healthType, setHealthType] = useState("");
    const [healthMaxRetires, setHealthMaxRetires] = useState("");
    const [healthId, setHealthId] = useState("");
    const [healthHttpMethod, setHealthHttpMethod] = useState("");
    const [healthMaxRetriesDown, setHealthMaxRetiresDown] = useState("");
    const [healthDelay, setHealthDelay] = useState("");
    const [healthTimeout, setHealthTimeout] = useState("");
    const [urlPath, setUrlPath] = useState("");
    const [urlPathError, setUrlPathError] = useState(false);
    const [urlPathErrorMsg, setUrlPathErrorMsg] = useState("");
    const [labelError, setLabelError] = useState(false);
    const [portError, setPortError] = useState(false);
    const [maxRetryError, setMaxRetryError] = useState(false);
    const [maxRetryErrorMsg, setMaxRetryErrorMsg] = useState("");
    const [maxRetriesDownError, setMaxRetriesDownError] = useState(false);
    const [maxRetriesDownErrorMsg, setMaxRetriesDownErrorMsg] = useState("");
    const [timeOutError, setTimeOutError] = useState(false);
    const [timeOutErrorMsg, setTimeOutErrorMsg] = useState("");
    const [delayError, setDelayError] = useState(false);
    const [delayErrorMsg, setDelayErrorMsg] = useState("");
    const [instancePortEmpty, setInstancePortEmpty] = useState(false);
    const [instanceWeightEmpty, setInstanceWeightEmpty] = useState(false);
    const [renameError, setRenameError] = useState(false);
    const [renameErrMsg, setRenameErrMsg] = useState(false);
    const [instanceEmpty, setInstanceEmpty] = useState(false);
    const [instanceIpAddrs, setInstanceIpAddrs] = useState("");
    const [instancePort, setInstancePort] = useState("");
    const [instanceWeight, setInstanceweight] = useState("");
    const [checkedEcodes, setCheckedEcodes] = useState([]);
    const [additionalIPs, setAdditionalIPs] = useState([]);
    const [tempInsVar, setTempInsVar] = useState(false);
    const [popUpScroll, setPopUpScroll] = useState(false);
    const [poolId, setPoolId] = useState("");
    const [loadDetails, setLoadDetails] = useState(false);
    const [editInsData, setEditInsData] = useState("");
    const [detachInsdata, setDetachInsData] = useState("");
    const [attachedIps, setAttachedIps] = useState([]);
    const [selectedInsId, setSelectedInsId] = useState("");
    const [selectedInsIp, setSelectedInsIp] = useState("");
    const [selectedInsName, setSelectedInsName] = useState("");
    const [additionalIPCount, setAdditionalIPCount] = useState(0);
    const [memberId, setMemberId] = useState("");
    const [showCookie, setShowCookie] = useState(false);
    const [cookieError, setCookieError] = useState(false);
    const [cookieErrMessage, setCookieErrMessage] = useState("");
    const [instancePortError, setInstancePortError] = useState(false);
    const [instanceWeightError, setInstanceWeightError] = useState(false);
    const [instanceWeightErrMsg, setInstanceWeightErrMsg] = useState("");
    const [instancePortErrMsg, setInstancePortErrMsg] = useState("");
    const [hideFields, setHideFields] = useState(false);
    const attachSelect = useRef();
    useEffect(() => {
        document.title = "IDrive® Compute | Manage Load Balancer";
        setLbName(loadBalData.name);
        setIsAction(true);
        checkForSubscription();

    }, []);
    useEffect(() => {
        const handleEsc = (event) => {
            if(event.keyCode === 27) {
                setPopUpScroll(false);
            }
        };
        window.addEventListener('keydown', handleEsc, false);

        return () => {
            window.removeEventListener('keydown', handleEsc, false);
            $("body").removeClass("no_scroll");
        };
    }, [setPopUpScroll]);
    useEffect(() => {
        if(tempInsVar)
            getLoadBalData();
    }, [tempInsVar]);
    useEffect(() => {
        if(loadDetails)
            getLoadBalDefaultData("before");
    }, [loadDetails]);

    const clearToastMessage = () => {
        setTimeout(() => {
            setMessage("");
            setMsgType("");
        }, 10000);
    };

    const inputHandler = () => {

    };
    const toggleEcodesDropdown = () => {
        $(".dropdown_component.addedcode_dropdown").toggleClass('active');
    };
    const handleCursorExpectedCodes = (inputList) => {
        if(inputList.length >= 3) {
            $('.tags_container').addClass('tags_wrap');
        }
        else {
            $('.tags_container').removeClass('tags_wrap');
        }
    };

    const filterCodes = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        let filtered = expectedCodes.filter(elem => !checkedEcodes.includes(elem));
        if(val.length > 0) {
            filtered = expectedCodes.filter(elem => elem == val);
        }
        setExpectedCodes(filtered);
    };
    const addOrRemoveExpectedCodes = (type, val) => {
        setEcodesError(false);
        setEcodesErrorMsg("");
        if(!isTypeNotHttpOrHttps) {
            if(type == "add") {
                toggleEcodesDropdown();
                let tempRemove = expectedCodes;
                tempRemove = tempRemove.filter((item) => val != item);
                let tempAdd = checkedEcodes;
                tempAdd.push(val);
                tempAdd.sort();
                handleCursorExpectedCodes(tempAdd);
                setExpectedCodes(tempRemove);
                setCheckedEcodes(tempAdd);

            }
            if(type == "remove") {
                toggleEcodesDropdown();
                let tempRemove = checkedEcodes;
                tempRemove = tempRemove.filter((item) => val != item);
                let tempAdd = expectedCodes;
                tempAdd.push(val);
                tempAdd.sort();
                handleCursorExpectedCodes(tempRemove);
                setExpectedCodes(tempAdd);
                setCheckedEcodes(tempRemove);

            }
        }
    };
    const enableDisableRename = (e, type) => {

        if(type === "enable") {
            $('.edit_lb_popup').addClass("active");
            setPopUpScroll(true);
            setLbName(loadBalConfigLabel);
            setRenameError(false);
        }
        else {

            $('.edit_lb_popup').removeClass("active");
            setPopUpScroll(false);
        }
    };
    const renameHandler = (event) => {

        const name = event.target.name;
        const val = event.target.value;
        if(val.length <= 0) {
            setRenameError(true);
            setRenameErrMsg("Label cannot be blank");
        }
        else {
            if(!Validate("firstName", val)) {
                setRenameError(true);
                setRenameErrMsg("Label can contain a-z, A-Z,-,_ and space");

            }
            else {
                setRenameError(false);
                setRenameErrMsg();
            }


        }
        setLbName(val);

    };
    const saveRename = () => {
        if(lbName.trim().length <= 0) {
            setRenameError(true);
            setRenameErrMsg("Label cannot be blank");
            return;
        }
        if(lbName.trim().length > 0) {
            if(!Validate("firstName", lbName)) {
                setRenameError(true);
                setRenameErrMsg("Label can contain a-z, A-Z,-,_ and space");
                return;
            }
        }
        setIsAction(true);
        $('.edit_lb_popup').removeClass("active");
        setPopUpScroll(false);
        let userId = localStorage.getItem("userId");
        let data = {
            "name": lbName.trim(),
            "oldName": lbOldName.trim(),
            "region": loadBalData.regionId
        };
        axiosInstance.put(API_HOST + "/loadbal/updatelbname/" + loadBalData.id + "/" + userId,
            {
                data
            }, axiosRequestWithAuth
        )
            .then(resp => {

                resp = resp.data;
                setIsAction(false);
                if(resp.body === "UPDATED") {
                    setMessage("Load balancer name updated successfully");
                    setLbName(data.name);
                    setLbOldName(data.name);
                    setLoadBalConfigLabel(data.name);
                    clearToastMessage();
                    return;
                }
                setMessage("Error while updating name, please try after sometime");
                clearToastMessage();
            })
            .catch(error => {
                setMessage("Error while updating name, please try after sometime");
                clearToastMessage();
            });
    };
    const configHandler = (event) => {
        const name = event.target.name;
        const val = event.target.value;
        if(name === "loadBalConfigAlgo")
            setLoadBalConfigAlgo(val);
        else if(name === "loadBalConfigSession") {
            setLoadBalConfigSession(val);
            if(val === "APP_COOKIE") {
                setShowCookie(true);

            }
            else {
                setShowCookie(false);
            }
        }

        else if(name === "loadBalConfigCookie") {
            setLoadBalConfigCookie(val);
            if(val.length <= 0) {
                setCookieError(true);
                setCookieErrMessage("Cookie name cannot be blank");
            }
            else {
                if(!Validate("firstName", val)) {
                    setCookieError(true);
                    setCookieErrMessage("Cookie name can contain a-z, A-Z,-,_ and space");
                }
                else {
                    setCookieError(false);
                    setCookieErrMessage("");
                }
            }
        }

    };
    const saveConfigChanges = () => {

        if(loadBalConfigSession === "APP_COOKIE" && loadBalConfigCookie.trim().length <= 0) {
            setCookieError(true);
            setCookieErrMessage("Cookie name cannot be blank");
            cookieRef.current.focus();
            return;
        }
        if(loadBalConfigSession === "APP_COOKIE" && loadBalConfigCookie.trim().length > 0) {
            if(!Validate("firstName", loadBalConfigCookie)) {
                setCookieError(true);
                setCookieErrMessage("Cookie name can contain a-z, A-Z,-,_ and space");
                cookieRef.current.focus();
                return;
            }

        }

        setIsAction(true);

        let userId = localStorage.getItem("userId");
        let data = {
            "algorithm": loadBalConfigAlgo,
            "session": loadBalConfigSession == null ? "NONE" : loadBalConfigSession,
            "region": loadBalData.regionId,
            "cookieName": showCookie ? loadBalConfigCookie.trim() : "none",
            "name": lbName
        };
        axiosInstance.put(API_HOST + "/loadbal/updateloadbalconfig/" + poolId + "/" + userId,
            {
                data
            }, axiosRequestWithAuth
        )
            .then(resp => {
                resp = resp.data;
                setIsAction(false);
                if(resp.body === "UPDATED") {
                    setMessage("Load balancer configuration details updated successfully");
                    clearToastMessage();
                    //getLoadBalDefaultData("after");
                    return;
                }
                setMessage("Error while updating configuration details");
                clearToastMessage();
            })
            .catch(error => {
                setMessage("Error while updating configuration details");
                clearToastMessage();
            });
    };
    const healthHandler = (event) => {
        const name = event.target.name;
        const val = event.target.value;
        setTimeOutError(false);
        setDelayError(false);
        setMaxRetriesDownError(false);
        setMaxRetryError(false);
        setUrlPathError(false);
        if(name === "healthType") {
            setHealthType(val);
            if(val === "HTTP" || val === "HTTPS") {
                setIsTypeNotHttpOrHttps(false);
            }
            else {
                setIsTypeNotHttpOrHttps(true);
            }
        }
        else if(name === "healthMaxRetriesDown") {

            setHealthMaxRetiresDown(val);
            if(val.length <= 0) {
                setMaxRetriesDownError(true);
                setMaxRetriesDownErrorMsg("Maximum retries down cannot be blank");
            }
            else {

                setMaxRetriesDownError(false);
                setMaxRetriesDownErrorMsg("");
            }
        }
        else if(name === "healthMaxRetires") {
            setHealthMaxRetires(val);
            if(val.length <= 0) {
                setMaxRetryError(true);
                setMaxRetryErrorMsg("Maximum retires cannot be blank");
            }
            else {
                setMaxRetryError(false);
                setMaxRetryErrorMsg("");
            }
        }
        else if(name === "healthDelay") {
            setHealthDelay(val);
            if(val.length <= 0) {
                setDelayError(true);
                setDelayErrorMsg("Delay cannot be blank");
            }
            else {
                setDelayError(false);
                setDelayErrorMsg("");
            }
        }
        else if(name === "healthTimeout") {
            setHealthTimeout(val);
            if(val.length <= 0) {
                setTimeOutError(true);
                setTimeOutErrorMsg("Timeout cannot be blank");
            }
            else {
                setTimeOutError(false);
                setTimeOutErrorMsg("");
            }
        }
        else if(name === "urlPath") {
            setUrlPath(val);
            if(healthType === "PING" || healthType === "UDP") {
                return;
            }

            if(val.length <= 0) {
                setUrlPathError(true);
                setUrlPathErrorMsg("URL path cannot be blank");
            }
            else {
                setUrlPathError(false);
                setUrlPathErrorMsg("");
            }
        }

        else if(name === "healthHttpMethod") {
            setHealthHttpMethod(val);
        }


    };
    const saveHealthChecks = (event) => {
        if(healthMaxRetriesDown.length <= 0) {
            setMaxRetriesDownError(true);
            setMaxRetriesDownErrorMsg("Maximum retries down cannot be blank");
            maxRetriesDownRef.current.focus();
            return;
        }
        if(healthMaxRetriesDown.length > 0) {
            const val = healthMaxRetriesDown;
            if(!Validate("noDecimals", Number(val)) || val < 1 || val > 10) {
                setMaxRetriesDownError(true);
                setMaxRetriesDownErrorMsg("Max retries down should be in the range of 1 and 10");
                maxRetriesDownRef.current.focus();
                return;
            }

        }
        if(healthTimeout.length <= 0) {

            setTimeOutError(true);
            setTimeOutErrorMsg("Timeout cannot be blank");
            timeoutRef.current.focus();
            return;
        }
        if(healthTimeout.length > 0) {

            const val = healthTimeout;
            if(!Validate("otp", Number(healthTimeout))) {
                setTimeOutError(true);
                setTimeOutErrorMsg("Enter a valid input");
                timeoutRef.current.focus();
                return;
            }
            if(Number(val) < 3 || Number(val) > 300) {
                setTimeOutError(true);
                setTimeOutErrorMsg("Timeout range must be in between 3 and 300 and less than or equal to the delay.");
                timeoutRef.current.focus();
                return;
            }
        }
        if(healthDelay.length <= 0) {
            setDelayError(true);
            setDelayErrorMsg("Delay cannot be blank");
            delayRef.current.focus();
            return;
        }
        if(healthDelay.length > 0) {
            const val = healthDelay;
            if(!Validate("otp", Number(healthDelay))) {
                setDelayError(true);
                setDelayErrorMsg("Enter a valid input.");
                delayRef.current.focus();
                return;
            }
            if(Number(val) < 3 || Number(val) > 300) {
                setDelayError(true);
                setDelayErrorMsg("Delay range must be in between 3 and 300 and greater than or equal to timeout.");
                delayRef.current.focus();
                return;
            }
        }
        if(healthMaxRetires.length <= 0) {
            setMaxRetryError(true);
            setMaxRetryError("Max retries cannot be blank");
            maxRetiresRef.current.focus();
            return;
        }
        if(healthMaxRetires.length > 0) {
            let val = healthMaxRetires;
            if(!Validate("noDecimals", Number(val)) || val < 1 || val > 10) {
                setMaxRetryError(true);
                setMaxRetryErrorMsg("Max retries should be in the range of 1 and 10");
                maxRetiresRef.current.focus();
                return;
            }
        }
        if(!isTypeNotHttpOrHttps) {
            if(checkedEcodes.length <= 0) {
                setEcodesError(true);
                setEcodesErrorMsg("Expected codes cannot be blank");
                expectedCodesRef.current.focus();
                return;
            }
            if(urlPath.length <= 0) {
                setUrlPathError(true);
                setUrlPathErrorMsg("URL path cannot be blank");
                urlRef.current.focus();
                return;
            }
        }
        if(Number(healthTimeout) > Number(healthDelay)) {
            setTimeOutError(true);
            setTimeOutErrorMsg("Timeout range must be in between 3 and 300 and less than or equal to the delay.");
            timeoutRef.current.focus();
            return;
        }
        if(Number(healthDelay) < Number(healthTimeout)) {
            setDelayError(true);
            setDelayErrorMsg("Delay range must be in between 3 and 300 and greater than or equal to timeout.");
            delayRef.current.focus();
            return;
        }
        let ecodes = "";
        if(checkedEcodes.length > 0) {
            checkedEcodes.forEach(elem => {
                ecodes = ecodes + elem + ",";
            });

        }

        const data = {
            "healthType": healthType,
            "maxRetries": healthMaxRetires,
            "maxRetriesDown": healthMaxRetriesDown,
            "timeout": healthTimeout,
            "delay": healthDelay,
            "httpMethod": isTypeNotHttpOrHttps ? "" : healthHttpMethod,
            "codes": isTypeNotHttpOrHttps ? "" : ecodes.substring(0, ecodes.length - 1),
            "urlPath": isTypeNotHttpOrHttps ? "" : urlPath
        };
        setIsAction(true);
        let userId = localStorage.getItem("userId");
        axiosInstance.put(API_HOST + "/loadbal/updatehealthchecks/" + healthId + "/" + userId + "?region=" + loadBalData.regionId + "&name=" + lbName, { data }, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data;
                if(resp.body === "UPDATED") {
                    setMessage("Health checks have been updated successfully");
                    setMsgType("");
                    setIsAction(false);
                    clearToastMessage();
                    return;
                }
                if(resp.body === "URL_PATH_ERROR") {
                    setIsAction(false);
                    setUrlPathError(true);
                    setUrlPathErrorMsg("Invalid URL path");
                    urlRef.current.focus();
                    return;
                }
                setMessage("Error while updating health checks, please try again after sometime.");
                setMsgType("error");
                setIsAction(false);
                clearToastMessage();
            })
            .catch(error => {
                setMessage("Error while updating health checks, please try again after sometime.");
                setIsAction(false);
                clearToastMessage();
            });
    };
    const enableInstanceOptions = (event) => {
        $(event.currentTarget).closest('.tr').find('.lbinstance_dropdown').toggleClass('active');
    };
    const enableInstanceOperations = (event, type, operation, data) => {
        setSelectedInsId("");
        setSelectedInsIp("");
        setInstancePort("");
        setInstancePortEmpty(false);
        setInstanceweight("");
        setInstanceWeightEmpty(false);
        setInstanceWeightError(false);
        if(type === "attach") {
            if(operation === "open") {
                $(".attach_instance_slider").addClass('active');
                $('body').addClass("no_scroll");
                setTimeout(() => {
                    attachSelect.current.focus();
                }, 100);
            }
            else {
                $(".attach_instance_slider").removeClass('active');
                $('body').removeClass("no_scroll");
            }
        }
        else if(type === "edit") {
            if(operation === "open") {
                $(".edit_instance_slider").addClass('active');
                $('body').addClass("no_scroll");
                setSelectedInsId(data.id);
                setSelectedInsName(data.name);
                setSelectedInsIp(data.ip);
                setMemberId(data.memberId);
                setInstancePort(data.port);
                setInstanceweight(data.weight);


            }
            else {
                $(".edit_instance_slider").removeClass('active');
                $('body').removeClass("no_scroll");
            }
        }
        else {
            if(operation === "open") {
                $(".delete_instance_popup").addClass('active');
                $('body').addClass("no_scroll");
                setSelectedInsName(data.name);
                setSelectedInsIp(data.ip);
                setMemberId(data.memberId);
            }
            else {
                $(".delete_instance_popup").removeClass('active');
                $('body').removeClass("no_scroll");
            }
        }
        event.stopPropagation();
    };
    const attachInstanceMethod = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        setSelectedInsId(val);
        setSelectedInsIp(getMainIp(val));
        setInstanceEmpty(false);

    };
    const handleInstanceData = (event) => {
        const name = event.target.name;
        const val = event.target.value;
        if(name === 'instancePort') {
            setInstancePort(val);
            if(val.length <= 0) {
                setInstancePortEmpty(true);
                setInstancePortError(false);
            }
            else {
                if(val < 1 || val > 65535) {
                    setInstancePortEmpty(false);
                    setInstancePortError(true);
                    setInstancePortErrMsg("Port should be between 1 and 65535");
                }
                else {
                    setInstancePortEmpty(false);
                    setInstancePortError(false);
                }

            }
        }
        if(name === 'instanceWeight') {
            setInstanceweight(val);
            if(val.length <= 0) {
                setInstanceWeightEmpty(true);
                setInstanceWeightError(false);
            }
            else {
                if(val < 1 || val > 256) {
                    setInstanceWeightEmpty(false);
                    setInstanceWeightError(true);
                    setInstanceWeightErrMsg("Weight should be between 1 and  256");
                }
                else {
                    setInstanceWeightEmpty(false);
                    setInstanceWeightError(false);
                }

            }
        }
    };
    const validateField = (evt) => {
        var theEvent = evt || window.event;

        // Handle paste
        if(theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\./;
        if(!regex.test(key)) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    };
    const attachInstance = (e) => {

        if(selectedInsIp.length <= 0) {

            setInstanceEmpty(true);
        }
        else if(instancePort.length <= 0) {
            setInstancePortEmpty(true);
        }
        else if(instancePort.length > 0 && !Validate("number", instancePort)) {
            setInstancePortEmpty(false);
            setInstancePortError(true);
            setInstancePortErrMsg("Port should be between 1 and 65535");

        }
        else if(instancePort < 1 || instancePort > 65535) {

            setInstancePortEmpty(false);
            setInstancePortError(true);
            setInstancePortErrMsg("Port should be between 1 and 65535");
        }
        else if(instanceWeight.length <= 0) {
            setInstanceWeightEmpty(true);
        }
        else if(instanceWeight.length > 0 && !Validate("number", instanceWeight)) {
            setInstanceWeightEmpty(false);
            setInstanceWeightError(true);
            setInstanceWeightErrMsg("Weight should be between 1 and 256");

        }

        else if(instanceWeight < 1 || instanceWeight > 256) {
            setInstanceWeightEmpty(false);
            setInstanceWeightError(true);
            setInstanceWeightErrMsg("Weight should be between 1 and 256");
        }
        else {

            $(".attach_instance_slider").removeClass('active');
            $('body').removeClass("no_scroll");
            setIsAction(true);
            const data = {
                "address": selectedInsIp,
                "port": instancePort,
                "weight": instanceWeight,
                "name": lbName
            };
            let userId = localStorage.getItem("userId");
            axiosInstance.post(API_HOST + "/loadbal/updatemembers/" + poolId + "/" + userId + "?region=" + loadBalData.regionId,
                { data }, axiosRequestWithAuth
            ).then(resp => {
                resp = resp.data;
                if(resp.body === "UPDATED") {
                    setMessage("Instance has been attached sucessfully");
                    getLoadBalDefaultData("after");
                    clearToastMessage();
                    return;
                }
                setMessage("Error while updating load balancer members, please try again.");
                setIsAction(false);
                clearToastMessage();

            }).catch(error => {
                setMessage("Error while updating load balancer members, please try again.");
                setIsAction(false);
                clearToastMessage();
            });
        }
    };
    const saveEditInsChanges = (e) => {
        if(instanceWeight.length <= 0) {
            setInstanceWeightEmpty(true);
        }
        else if(instanceWeight.length > 0 && !Validate("number", instanceWeight)) {
            setInstanceWeightEmpty(false);
            setInstanceWeightError(true);
            setInstanceWeightErrMsg("Weight should be between 1 and 256");

        }
        else if(instanceWeight < 1 || instanceWeight > 256) {
            setInstanceWeightEmpty(false);
            setInstanceWeightError(true);
            setInstanceWeightErrMsg("Weight should be between 1 and 256");
        }
        else {
            $(".edit_instance_slider").removeClass('active');
            $('body').removeClass("no_scroll");
            setIsAction(true);

            const data = {
                "weight": instanceWeight,
                "name": lbName
            };
            let userId = localStorage.getItem("userId");
            axiosInstance.post(API_HOST + "/loadbal/editmember/" + poolId + "/" + memberId + "/" + userId + "?region=" + loadBalData.regionId,
                { data }, axiosRequestWithAuth
            ).then(resp => {
                resp = resp.data;
                if(resp.body === "UPDATED") {
                    setMessage("Instance weight has been updated sucessfully");
                    getLoadBalDefaultData("after");
                    clearToastMessage();
                    return;
                }
                setMessage("Error while updating load balancer members, please try again.");
                setIsAction(false);
                clearToastMessage();

            }).catch(error => {
                setMessage("Error while updating load balancer members, please try again.");
                setIsAction(false);
                clearToastMessage();
            });
        }
    };
    const detachMember = (e) => {
        $(".delete_instance_popup").removeClass('active');
        $('body').removeClass("no_scroll");
        setIsAction(true);
        let userId = localStorage.getItem("userId");
        axiosInstance.delete(API_HOST + "/loadbal/deletemember/" + poolId + "/" + memberId + "/" + userId + "?region=" + loadBalData.regionId + "&name=" + lbName + "&insIp=" + selectedInsIp,
            axiosRequestWithAuth
        ).then(resp => {
            resp = resp.data;
            if(resp.body === "DELETED") {
                setMessage("Instance of load balancer has been detached sucessfully");
                getLoadBalDefaultData("after");
                clearToastMessage();
                return;
            }
            setMessage("Error while detaching load balancer member, please try again.");
            setIsAction(false);
            clearToastMessage();

        }).catch(error => {
            setMessage("Error while detaching load balancer member, please try again.");
            setIsAction(false);
            clearToastMessage();
        });
    };
    const getAdditionalIpDetails = () => {

        NetworkService.getIPDetailsByUser().then(resp => {
            if(resp === false) {
                setIsAction(false);
            }
            if(resp.data == "NO_DETAILS_FOUND") {
                setAdditionalIPCount(0);
                setAdditionalIPs([]);
            }
            if(resp.data != "NO_DETAILS_FOUND") {
                setAdditionalIPCount(resp.data.length);
                setAdditionalIPs(resp.data);


            }
            getRegionUrl(loadBalData.regionId);


        })
            .catch(error => {
                setIsAction(false);
            });
    };
    const getMainIp = (serverId) => {
        let instances = instanceList;
        let ipList = instances.find(elem => elem.id === serverId);
        ipList = ipList.ip;
        let compute = additionalIPs;
        if(compute.length > 0) {
            let result = [];
            for(let i = 0; i < compute.length; i++) {
                if(compute[i].instance_id == serverId)
                    result.push(compute[i].ip_address);
            }
            var final = ipList.filter(function (obj) { return result.indexOf(obj) == -1; });
            return final[0];
        }
        else {
            return ipList[0];
        }

    };
    const getLoadBalDefaultData = (param) => {

        if(param === "after")
            setIsAction(true);
        let loadBalId = loadBalData.id;
        let loadBalRegion = loadBalData.regionId;
        let attchedInsList = [];
        let attchedIps = [];
        LoadBalancerService.getLoadBalDefaultConfig(loadBalId, loadBalRegion).then(resp => {
            if(resp) {
                let ecodes = [];
                let loadbalancer = resp.loadBalancer;
                let pool = resp.pool;
                let health = resp.health;
                let listener = resp.listener;
                let members = resp.members;
                if(health.expected_codes != null) {
                    let codes = health.expected_codes.split(",");
                    if(codes.length > 0) {
                        for(let i = 0; i < codes.length; i++) {
                            ecodes.push(Number(codes[i]));
                        }
                    }
                }

                let instances = instanceList;
                for(let i = 0; i < members.length; i++) {
                    for(let j = 0; j < instances.length; j++) {

                        if(members[i].address === getMainIp(instances[j].id)) {
                            let obj = {
                                "id": instances[j].id,
                                "name": instances[j].name,
                                "ip": members[i].address,
                                "status": members[i].operating_status,
                                "port": members[i].protocol_port,
                                "weight": members[i].weight,
                                "memberId": members[i].id
                            };
                            attchedInsList.push(obj);
                            attchedIps.push(members[i].address);

                        }
                    }
                }
                const finalArr = instances.filter(({ id }) =>
                    !attchedInsList.some(exclude => exclude.id === id)
                );
                setAttachedInstance(attchedInsList);
                setFilteredIns(finalArr);
                setCheckedEcodes(ecodes);
                let filtered = expectedCodes.filter(elem => !ecodes.includes(elem));
                if(ecodes.length >= 3) {
                    $('.tags_container').addClass('tags_wrap');
                }
                else {
                    $('.tags_container').removeClass('tags_wrap');
                }

                console.log(filtered);
                setExpectedCodes(filtered);

                setLoadBalConfigLabel(loadbalancer.name);
                setLbName(loadbalancer.name);
                setLbOldName(loadbalancer.name);
                setLoadBalConfigAlgo(pool.lb_algorithm);

                if(pool.session_persistence != null && pool.session_persistence.hasOwnProperty("type")) {
                    setLoadBalConfigSession(pool.session_persistence.type);
                    if(pool.session_persistence.type === "APP_COOKIE") {
                        setShowCookie(true);
                        setLoadBalConfigCookie(pool.session_persistence.cookie_name);
                    }


                }


                else
                    setLoadBalConfigSession(pool.session_persistence);
                setPoolId(pool.id);
                setPort(listener.protocol_port);
                setProtocol(listener.protocol);
                setHealthId(health.id);
                setHealthType(health.type);
                setHealthMaxRetires(health.max_retries);
                setHealthMaxRetiresDown(health.max_retries_down);
                setHealthDelay(health.delay);
                setHealthTimeout(health.timeout);
                if(health.http_method != null) {
                    setHealthHttpMethod(health.http_method);
                    setUrlPath(health.url_path);
                }

                if(!(health.type === "HTTPS" || health.type === "HTTP")) {
                    setIsTypeNotHttpOrHttps(true);
                }

                setIsAction(false);

            }
            else {

                setMsgType('error');
                setMessage("Error while fetching load balancer details");
                setIsAction(false);
                clearToastMessage();
            }
        })
            .catch(error => {

                setMsgType('error');
                setMessage("Error while fetching load balancer details");
                setIsAction(false);
                clearToastMessage();
            });
    };
    const getLoadBalData = () => {

        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + '/loadbal/getloadbalops/' + userId, axiosRequestWithAuth)
            .then(resp => {
                if(resp) {
                    resp = resp.data;
                    setAlgoList(resp.algorithm);
                    setSessionTypes(resp.sessionTypes);
                    setProtocols(resp.protocols);
                    setHealthChecks(resp.healthChecks);
                    setHttpMethods(resp.httpmethods);
                    setExpectedCodes(resp.expectedCodes);
                    setHealthChecksSelectedECodes(resp.expectedCodes.slice(0, 1));
                    setHealthChecksUrl(resp.url);
                    setLoadDetails(!loadDetails);

                }
                else {
                    setIsAction(false);
                }


            })
            .catch(error => {
                console.log(error);
                setIsAction(false);
            });


    };
    const checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            // console.log(resp);
            if(resp === false) {
                setIsAction(false);
                setMsgType('error');
                setMessage("User not subscribed");
                clearToastMessage();
                return;
            }
            if(resp.error) {
                setIsAction(false);
                setIsUserSubscribed(true);
                setMessage("Error while getting user details");
                clearToastMessage();
            }
            else {
                getAdditionalIpDetails();


            }

        });
    };


    const getRegionUrl = (regionId) => {
        regionId = regionId.toUpperCase();
        ServerService.getRegionListByType('compute').then(regionList => {

            if(regionList) {
                let region = regionList.find(regionItem => regionItem.region_id === regionId);
                setRegionUrl(region.url);
                updateInstanceList(region.url);

            }
            if(!Array.isArray(regionList)) {
                setMsgType('error');
                setMessage("Error while fetching region details");
                clearToastMessage();
                isAction(false);
            }
        });
    };

    const updateInstanceList = (regionUrl) => {
        let tempInstanceList = [];
        ServerService.getServerListByRegion(regionUrl).then(resp => {
            if(resp.length > 0) {
                resp.forEach(instance => {
                    if(instance.status == "ACTIVE") {

                        let tempInstanceData = {
                            "id": instance.id,
                            "name": instance.name,
                            "ip": instance.ipaddress
                        };
                        tempInstanceList.push(tempInstanceData);
                    }
                });
                setInstanceList(tempInstanceList);
            }
            setTempInsVar(!tempInsVar);
        });
    };

    const convertToCamelCase = (str) => {
        return str.split(/[ ,_-]+/).map(function (word, index) {
            if(word === "IP" || word === "UDP")
                return word;
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    };

    return (
        <body className={ popUpScroll ? "manageLb_ui no_scroll" : "manageLb_ui" }>
            { isCCAdded &&
                <Redirect to={ {
                    pathname: "/billing/creditcard",
                    state: { message: true }
                } }></Redirect>
            }

            <main>
                <div className="full_page_loader" style={ { display: isAction ? "block" : "none" } }>
                    <div className="loader_icon"></div>
                </div>
                <LeftNav isActive={ 'loadbal' }></LeftNav>
                <div className="main_container">
                    <header className="header_wrap">
                        <HeaderTop showCreate={ true } isUserSubscribed={ isUserSubscribed }></HeaderTop>
                        <div className="header_wrap_bottom manageLb_btm_header">
                            <div className="bottom_navbar">
                                <div className="bn_left">
                                    <span className="bck_icon" data-tip data-for="backBtn" currentitem="false" onClick={ () => props.history.push("/load-balancers") }>
                                        <span className="svg_wrap">➔</span>
                                    </span>
                                    <ReactToolTip id="backBtn" place="right" effect='solid'>Back to load balancers list page</ReactToolTip>
                                    <div className="title_txt">
                                        <span>Manage Load Balancer</span>
                                        <span className="title_info">{ loadBalData.region } | { loadBalData.ip } </span>
                                    </div>
                                </div>
                                <div className="bn_right">
                                    <div className="lb_edit" data-tip="true" data-for="" onClick={ (e) => enableDisableRename(e, "enable") }>
                                        <span className="svg_wrap" >
                                            <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" className="edit_ico" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                        </span>Rename
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <section className="main_section">
                        <div className="main_body_container">
                            <aside className="manageLb_nav">
                                <div className="settingModule_bg_shadow"></div>
                                <ul>
                                    <a href="lbManage-overview.html">
                                        <li className="">
                                            <span className="svg_wrap">
                                                <svg x="0px" y="0px" viewBox="0 0 16.9 13.5" enableBackground="new 0 0 16.9 13.5" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#868686" d="M15.1,12.7H1.8c-0.7,0-1.4-0.6-1.4-1.4V2.1c0-0.7,0.6-1.4,1.4-1.4  h13.3c0.7,0,1.4,0.6,1.4,1.4v9.3C16.4,12.1,15.8,12.7,15.1,12.7z M15.4,1.7h-14v10h14V1.7z M4,7.1C3.7,6.8,3.4,6.3,3.4,5.7  c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.5-0.2,1-0.6,1.4c0.9,0.5,1.6,1.5,1.6,2.6h-1c0-1.1-0.9-2-2-2s-2,0.9-2,2h-1C2.4,8.6,3.1,7.6,4,7.1z   M5.4,6.7c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S4.9,6.7,5.4,6.7z M14.4,5.7h-5v-1h5V5.7z M12.4,7.7h-3v-1h3V7.7z" />
                                                </svg>
                                            </span>Overview
                                        </li>
                                    </a>
                                    <a href="lbManage-config.html">
                                        <li className="active">
                                            <span className="svg_wrap">
                                                <svg x="0px" y="0px" viewBox="0 0 16.9 13.5" enableBackground="new 0 0 16.9 13.5" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#868686" d="M15.2,12.8H1.7c-0.7,0-1.3-0.6-1.3-1.3V6.8v-1v-1v-1V2  c0-0.7,0.6-1.3,1.3-1.3h13.4c0.7,0,1.3,0.6,1.3,1.3v1.7v1v6.7C16.5,12.2,15.9,12.8,15.2,12.8z M15.4,1.8h-14v2h14V1.8z M15.4,4.8  h-14v1h5v1h-5v5h14V4.8z M9.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S8.9,7.8,9.4,7.8z M12.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1  s-1-0.4-1-1S11.9,7.8,12.4,7.8z" />
                                                </svg>
                                            </span>Configuration
                                        </li>
                                    </a>
                                </ul>
                            </aside>
                            <section className="manageLb_wrapper">

                                <div className="manageLb_configWrap">
                                    <div className="lb_instanceTable">
                                        <div className="lb_instanceTable_head">
                                            <h3>Attach Instance
                                                <span className="question_icon" data-tip data-for="attachText" >
                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                    </svg>
                                                </span>
                                                <ReactToolTip id="attachText" place='right' effect="solid">
                                                    The incoming network traffic<br></br> load of the selected instance<br></br> will be evenly distributed <br></br>among other instances attached<br></br> to the load balancer for faster performance
                                                </ReactToolTip>
                                            </h3>
                                            <p>Attach an instance to the load balancer</p>
                                            <div className="btn_wrap">
                                                <input type="button" name="" className="common_cta_btn attach_instBtn" value="Attach Instance" onClick={ (e) => enableInstanceOperations(e, "attach", "open", "") } />
                                            </div>
                                        </div>
                                        <div className="tabular_data_wrap">
                                            <div className="table_header">
                                                <ul>
                                                    <li className="th">
                                                        <div className="col col1"><div className="">Name<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                        <div className="col col2"><div className="">IP Address<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                        <div className="col col3"><div className="">Status<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                        <div className="col col4"><div className="">Port<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                        <div className="col col5"><div className="">Weight<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                        <div className="col col6">Actions</div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="table_data">
                                                <ul>{ attachedInstance.length <= 0 ?
                                                    <li class="tr table_data_empty">
                                                        <div class="outer_empty_wrap">
                                                            <div class="inner_empty_wrap">
                                                                <div class="svg_wrap empty_icon lb_instance_empty"></div>
                                                                <p class="empty_title">No instances found</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    : attachedInstance.map((instance, index) =>
                                                        <li className="tr" key={ index }>
                                                            <div className="col col1">
                                                                <span data-for={ instance.ip } data-tip>{ instance.name }</span>
                                                                { instance.name.length > 30 ?
                                                                    <ReactToolTip id={ instance.ip } place="top" effect='solid'>{ instance.name }</ReactToolTip> : ""
                                                                }
                                                            </div>
                                                            <div className="col col2">{ instance.ip }</div>
                                                            <div className="col col3">
                                                                <span className={ "server_status " + instance.status.toLowerCase() }>{ convertToCamelCase(instance.status) }</span>
                                                            </div>
                                                            <div className="col col4">{ instance.port }</div>
                                                            <div className="col col5">{ instance.weight }</div>
                                                            <div className="col col6">
                                                                <span className="icon menu_icon" onClick={ (e) => enableInstanceOptions(e, instance) }>
                                                                    <svg className="horizMenuIcon" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                    </svg>
                                                                    <ul className="dropdown_component lbinstance_dropdown">
                                                                        <span className="arrow_pointer"></span>
                                                                        <li className="edit" onClick={ (e) => enableInstanceOperations(e, "edit", "open", instance) }>
                                                                            <span className="icon">
                                                                                <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                                            </span>Edit
                                                                        </li>
                                                                        <li className="detach" onClick={ (e) => enableInstanceOperations(e, "detach", "open", instance) }>
                                                                            <span className="icon">
                                                                                <svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve"><g><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M5.2,13.9c1.2,1.2,2.7,1.3,4,0l1.3-1.3l-1.3-1.3l-1.3,1.3   c-0.6,0.5-0.8,0.5-1.3,0c-0.5-0.5-0.6-0.8,0-1.3l1.3-1.3L6.5,8.6L5.2,9.9C3.9,11.2,4,12.7,5.2,13.9z"></path><polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="15.2,13.2 17.9,10.6 16.5,9.3 13.9,11.9  "></polygon><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M7.3,5.2l1.9-1.9C10.5,2,12.8,1.5,14,2.7c1.2,1.2,0.5,3.3-0.8,4.5   l-2,1.9l1.3,1.3l2-1.9c2-2,2.6-5.3,0.8-7.2C13.4-0.5,9.9,0,7.9,2L5.9,3.9L7.3,5.2z"></path><polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="11.2,4 8.6,6.6 9.9,7.9 12.5,5.3  "></polygon><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M11.9,13.9l-1.3,1.3c-2,2-4.8,1.9-6.7,0c-1.9-1.9-2-4.6,0-6.6   l1.3-1.3L3.9,5.9l-1,1C0.1,9.7,0,14,2.5,16.5c2.6,2.6,6.9,2.4,9.7-0.3l1-1L11.9,13.9z"></path></g><rect x="7.8" y="1.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.946 9.1295)" fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" width="1.5" height="18"></rect></svg>
                                                                            </span>Detach
                                                                        </li>
                                                                    </ul>
                                                                </span>
                                                            </div>
                                                        </li>) }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="config_blks lb_config">
                                        <div className="config_blks_cont">
                                            <div className="field_sec_wrap">
                                                <h3>Load Balancer Configuration
                                                    <span className="question_icon" data-tip data-for="loadconfig">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span>
                                                    <ReactToolTip id="loadconfig" place="right" effect='solid'>Configure load balancer settings<br /> to route connection requests to <br />the attached instances</ReactToolTip>
                                                </h3>
                                                <p>Select the required network port and protocal for load balancing</p>
                                                <div className="field_wrap">
                                                    <div className="common_txtBox_row">
                                                        <label>Label</label>
                                                        <input type="text" autoComplete="off" maxLength="20" name="loadBalConfigLabel" className="txtBox" value={ loadBalConfigLabel } readOnly disabled />
                                                        <span className="err_msg" style={ { display: labelError ? "block" : "none" } }>Label cannot be empty</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Algorithm</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="loadBalConfigAlgo" id="algorithm" value={ loadBalConfigAlgo } onChange={ (e) => configHandler(e) }>
                                                                { algorithmList.map((item, index) =>
                                                                    <option key={ index } value={ item }>{ convertToCamelCase(item.trim()) }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="err_msg" style={ { display: "none" } }>Error msg comes here</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Sticky Session</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="loadBalConfigSession" id="algorithm" value={ loadBalConfigSession } onChange={ (e) => configHandler(e) } >
                                                                { sessionTypes.map((item, index) =>
                                                                    <option key={ index } value={ item }>{ convertToCamelCase(item.trim()) }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                        <span className="err_msg" style={ { display: "none" } }>First name can contain a-z, A-Z and space</span>
                                                    </div>
                                                    <span className="err_msg" style={ { display: "none" } }>{ message }</span>
                                                    <div className="common_txtBox_row" style={ { display: showCookie ? "block" : "none" } }>
                                                        <label>Cookie Name</label>
                                                        <input type="text" ref={ cookieRef } placeholder="Name of session cookie" autoComplete="off" maxLength="20" name="loadBalConfigCookie" className="txtBox" value={ loadBalConfigCookie } onChange={ (e) => configHandler(e) } />
                                                        <span className="err_msg" style={ { display: cookieError ? "block" : "none" } }>{ cookieErrMessage }</span>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div className="btn-blk btn-config">
                                            <input type="submit" name="config" className="common_cta_btn blue" value="Save changes" onClick={ () => saveConfigChanges("") } />
                                        </div>
                                    </div>
                                    <div className="config_blks lb_config">
                                        <div className="config_blks_cont">
                                            <div className="field_sec_wrap">
                                                <h3>Port Configuration
                                                    <span className="question_icon" data-tip data-for="portconfig">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span>
                                                    <ReactToolTip id="portconfig" place="right" effect='solid'>The selected port must match the <br />port used on the attached <br />instances</ReactToolTip>
                                                </h3>
                                                <p>Add a port that the load balancer will listen on</p>
                                                <div className="field_wrap">
                                                    <div className="common_txtBox_row">
                                                        <label>Port</label>
                                                        <input type="text" autoComplete="off" maxLength="20" name="port" className="txtBox" value={ port } onChange={ (e) => inputHandler(e, "port", "port") } disabled={ true } />
                                                        <span className="err_msg" style={ { display: portError ? "block" : "none" } }>Port cannot be blank</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Protocol</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="protocol" id="algorithm" value={ protocol } onChange={ (e) => inputHandler(e, "port", "protocol") } disabled={ true }>
                                                                { protocols.map((item, index) =>
                                                                    <option key={ index } value={ item }>{ convertToCamelCase(item.trim()) }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="err_msg" style={ { display: "none" } }></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="config_blks lb_config">
                                        <div className="config_blks_cont">
                                            <div className="field_sec_wrap">
                                                <h3>Health Checks
                                                    <span className="question_icon" data-tip data-for="healthcheck" >
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span>
                                                    <ReactToolTip id="healthcheck" place="right" effect='solid'>The load balancer will periodically<br />check the status of the attached <br />instances as connection requests<br /> are routed only to healthy <br />instances</ReactToolTip>
                                                </h3>
                                                <p>Add a health check route to the attached instances</p>
                                                <div className="field_wrap">
                                                    <div className="common_txtBox_row">
                                                        <label>Type</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="healthType" id="algorithm" value={ healthType } onChange={ (e) => healthHandler(e) } disabled>
                                                                { healthChecks.map((item, index) =>
                                                                    <option key={ index } value={ item }>{ convertToCamelCase(item.trim()) }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="err_msg" style={ { display: "none" } }></span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Max Retries Down</label>
                                                        <input type="text" ref={ maxRetriesDownRef } autoComplete="off" maxLength="20" name="healthMaxRetriesDown" className="txtBox" placeholder="" value={ healthMaxRetriesDown } onChange={ (e) => healthHandler(e) } onKeyPress={ (event) => validateField(event) } />
                                                        <span className="err_msg" style={ { display: maxRetriesDownError ? "block" : "none" } }>{ maxRetriesDownErrorMsg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Timeout(sec)</label>
                                                        <input type="text" ref={ timeoutRef } autoComplete="off" maxLength="20" name="healthTimeout" className="txtBox" placeholder="" value={ healthTimeout } onChange={ (e) => healthHandler(e) } onKeyPress={ (event) => validateField(event) } />
                                                        <span className="err_msg" style={ { display: timeOutError ? "block" : "none" } }>{ timeOutErrorMsg }</span>
                                                    </div>
                                                </div>
                                                <div className="field_wrap">
                                                    <div className="common_txtBox_row">
                                                        <label>Max Retries</label>
                                                        <input type="text" ref={ maxRetiresRef } autoComplete="off" maxLength="20" name="healthMaxRetires" className="txtBox" placeholder="" value={ healthMaxRetires } onChange={ (e) => healthHandler(e) } onKeyPress={ (event) => validateField(event) } />
                                                        <span className="err_msg" style={ { display: maxRetryError ? "block" : "none" } }>{ maxRetryErrorMsg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Delay(sec)</label>
                                                        <input type="text" ref={ delayRef } autoComplete="off" maxLength="20" name="healthDelay" className="txtBox" placeholder="" value={ healthDelay } onChange={ (e) => healthHandler(e) } onKeyPress={ (event) => validateField(event) } />
                                                        <span className="err_msg" style={ { display: delayError ? "block" : "none" } }>{ delayErrorMsg }</span>
                                                    </div>
                                                </div>
                                                <div className="field_wrap" style={ { display: isTypeNotHttpOrHttps ? "none" : "" } }>
                                                    <div className="common_txtBox_row">
                                                        <label>HTTP Method</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="healthHttpMethod" id="algorithm" value={ healthHttpMethod } onChange={ (e) => healthHandler(e) } disabled={ isTypeNotHttpOrHttps }>
                                                                { httpMethods.map((item, index) =>
                                                                    <option key={ index } value={ item }>{ convertToCamelCase(item.trim()) }</option>
                                                                ) }
                                                            </select>
                                                        </div>
                                                        <span className="err_msg" style={ { display: "none" } }></span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>Expected Codes</label>
                                                        <div className="custom_selectBox expCode_blk">
                                                            <div className="added_applyInstance">
                                                                <ul className="tags_container" onClick={ (e) => { toggleEcodesDropdown(); } }>
                                                                    {
                                                                        checkedEcodes.map((item, idx) =>
                                                                            <li key={ idx } >
                                                                                <div className="source_tag" >
                                                                                    <div className="row_wrap" >
                                                                                        <span className="row row_head" >{ item }</span>
                                                                                    </div>
                                                                                    <span className="close_icon" title='Close' onClick={ () => addOrRemoveExpectedCodes("remove", item) }></span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    }
                                                                    <span className="inp_box">
                                                                        <input id="inpSearch" ref={ expectedCodesRef } type="hidden" name="inpSearch" className="input_search" autoComplete="off" onChange={ (e) => filterCodes(e) } disabled={ isTypeNotHttpOrHttps } readOnly />

                                                                    </span>
                                                                </ul>
                                                                <div className="dropdown_component addedcode_dropdown">
                                                                    {
                                                                        (expectedCodes.length > 0) ?
                                                                            <ul>
                                                                                { expectedCodes.map((item, idx) =>
                                                                                    <li key={ idx }>
                                                                                        <span className="code_value" onClick={ () => addOrRemoveExpectedCodes("add", item) }>{ item }</span>
                                                                                    </li>
                                                                                ) }
                                                                            </ul>
                                                                            :
                                                                            <li>No codes available to apply</li>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className="err_msg" style={ { display: ecodesError ? "block" : "none" } }>{ ecodesErrorMsg }</span>
                                                    </div>
                                                    <div className="common_txtBox_row">
                                                        <label>URL Paths</label>
                                                        <input type="text" ref={ urlRef } autoComplete="off" maxLength="20" name="urlPath" className="txtBox" placeholder="" value={ urlPath } onChange={ (e) => healthHandler(e) } disabled={ isTypeNotHttpOrHttps } />
                                                        <span className="err_msg" style={ { display: urlPathError ? "block" : "none" } }>{ urlPathErrorMsg }</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="btn-blk btn-health">
                                            <input type="submit" name="health" className="common_cta_btn blue" value="Save changes" onClick={ (e) => saveHealthChecks(e) } />
                                        </div>
                                    </div>

                                </div>
                            </section>
                        </div>
                    </section>
                </div>
            </main>



            <div className="main_popup edit_lb_popup ">
                <div className="main_popup_wrapper">
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap">
                            <span className="close_icon" data-tip data-for="closeRename" onClick={ (e) => enableDisableRename(e, "disable") }></span>
                            <ReactToolTip id="closeRename" place='top' effect='solid'>Close</ReactToolTip>
                            <div className="popup_header">
                                <div className="sub_title"> Rename <b> </b></div>
                            </div>
                            <div className="popup_body">
                                <div className="common_txtBox_row">
                                    <label>Label</label>
                                    <input id="rename" type="text" maxLength="20" placeholder="Provide a new name" autoComplete="off" name="lbName" className="txtBox edit_name_inp" tabIndex="1" value={ lbName } onChange={ renameHandler } />
                                    <span className="comm_error_msg" style={ { display: renameError ? "block" : "none" } }>{ renameErrMsg }</span>
                                </div>
                            </div>
                            <div className="popup_footer">
                                <div className="popup_footer__btns">
                                    {/* onchange={(e) => setRename(e)} */ }
                                    <button className="btn blue" tabIndex="2" onClick={ () => saveRename() }>Save Changes</button>
                                    <button className="btn btn_cancel" tabIndex="3" onClick={ (e) => enableDisableRename(e, "disable") }>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main_slider attach_instance_slider " >
                <div className="slider_bg_shadow"></div>
                <div className="slider_wrapper">
                    <div className="main_slider_container">
                        <div className="close_icon" onClick={ (e) => enableInstanceOperations(e, "attach", "close", "") }></div>
                        <div className="attach_instance_slide_wrap">
                            <div className="head_block">
                                <h2>
                                    <span className="icon_img"><span className="icon"></span></span>Attach Instance</h2>
                            </div>
                            <div className="content_wrap">
                                <p>The incoming network traffic load of the selected instance will be evenly distributed among other instances attached to the load balancer for faster performance.</p>
                                <div className="common_txtBox_row">
                                    <label>Name</label>
                                    <div className="custom_select_box">
                                        <select name="instanceAttacher" ref={ attachSelect } value={ selectedInsId } className="txt_box" onChange={ (e) => attachInstanceMethod(e) }>
                                            { filteredIns.length === 0 ? <option value='' default>No instance available</option> : <option value='' style={ { display: "none" } } default>Select an instance to attach</option> }
                                            {
                                                filteredIns.length > 0 && filteredIns.map((instance, key) =>
                                                    <option key={ key } value={ instance.id } >{ instance.name }</option>
                                                )
                                            }

                                        </select>
                                    </div>
                                    <span className="err_msg" style={ { display: instanceEmpty ? "" : "none" } }>Select any instance</span>

                                </div>
                                <div className="common_txtBox_row">
                                    <label>IPv4 Address</label>
                                    <input type="text" name='selectedInsIp' value={ selectedInsIp } className="txt_box" disabled={ true } />
                                </div>
                                <div className="common_txtBox_row">
                                    <label>Port</label>
                                    <input type="text" autoComplete='off' name="instancePort" value={ instancePort } className="txt_box" onChange={ (e) => handleInstanceData(e) } onKeyPress={ (event) => validateField(event) } />
                                    <span className="err_msg" style={ { display: instancePortEmpty ? "" : "none" } }>Port cannot be blank </span>
                                    <span className="err_msg" style={ { display: instancePortError ? "" : "none" } }>{ instancePortErrMsg } </span>
                                </div>
                                <div className="common_txtBox_row">
                                    <label>Weight</label>
                                    <input type="text" autoComplete='off' name="instanceWeight" value={ instanceWeight } className="txt_box" onChange={ (e) => handleInstanceData(e) } onKeyPress={ (event) => validateField(event) } />
                                    <span className="err_msg" style={ { display: instanceWeightEmpty ? "" : "none" } }>Weight cannot be blank </span>
                                    <span className="err_msg" style={ { display: instanceWeightError ? "" : "none" } }>{ instanceWeightErrMsg } </span>
                                </div>
                                <div className="cta_wrap">
                                    <input type="button" name="" className="common_cta_btn blue" value="Attach" onClick={ (e) => attachInstance(e) } />
                                    <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel" onClick={ (e) => enableInstanceOperations(e, "attach", "close", "") } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main_slider edit_instance_slider " >
                <div className="slider_bg_shadow"></div>
                <div className="slider_wrapper">
                    <div className="main_slider_container">
                        <div className="close_icon" onClick={ (e) => enableInstanceOperations(e, "edit", "close", "") }></div>
                        <div className="edit_instance_slide_wrap">
                            <div className="head_block">
                                <h2>
                                    <span className="icon_img">
                                        <span className="icon">
                                            <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                        </span>
                                    </span>Edit Instance</h2>
                            </div>
                            <div className="content_wrap">
                                <p>The incoming network traffic load of the selected instance will be evenly distributed among other instances attached to the load balancer for faster performance.</p>
                                <div className="common_txtBox_row">
                                    <label>Name</label>
                                    <input type="text" name='instanceAttacher' value={ selectedInsName } className="txt_box" disabled={ true } />

                                </div>
                                <div className="common_txtBox_row">
                                    <label>IPv4 Address</label>
                                    <input type="text" name='selectedInsIp' value={ selectedInsIp } className="txt_box" disabled={ true } />
                                </div>
                                <div className="common_txtBox_row">
                                    <label>Port</label>
                                    <input type="text" autoComplete='off' name="instancePort" value={ instancePort } className="txt_box" disabled={ true } />
                                    <span className="err_msg" style={ { display: instancePortEmpty ? "" : "none" } }>Port cannot be blank </span>
                                </div>
                                <div className="common_txtBox_row">
                                    <label>Weight</label>
                                    <input type="text" autoComplete='off' name="instanceWeight" value={ instanceWeight } className="txt_box" onChange={ (e) => handleInstanceData(e) } onKeyPress={ (event) => validateField(event) } />
                                    <span className="err_msg" style={ { display: instanceWeightEmpty ? "" : "none" } }>Weight cannot be blank </span>
                                    <span className="err_msg" style={ { display: instanceWeightError ? "" : "none" } }>{ instanceWeightErrMsg } </span>
                                </div>
                                <div className="cta_wrap">
                                    <input type="button" name="" className="common_cta_btn blue" value="Save changes" onClick={ (e) => saveEditInsChanges(e) } />
                                    <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel" onClick={ (e) => enableInstanceOperations(e, "edit", "close", "") } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main_popup delete_instance_popup">
                <div className="main_popup_wrapper">
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap"> <span className="close_icon" onClick={ (e) => enableInstanceOperations(e, "detach", "close", "") }></span>
                            <div className="popup_header">
                                <div className="sub_title"> Detach { selectedInsName }</div>
                            </div>
                            <div className="popup_body">
                                <p>Are you sure you want to detach the instance from the load balancer?</p>
                            </div>
                            <div className="popup_footer">
                                <div className="popup_footer__btns">
                                    <div className="btn btn_confirm" onClick={ (e) => detachMember(e) }>Detach</div>
                                    <div className="btn btn_cancel" onClick={ (e) => enableInstanceOperations(e, "detach", "close", "") }>Cancel</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main_popup detach_instance_popup">
                <div className="main_popup_wrapper">
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap">
                            <span className="close_icon" data-tip data-for="closedetach" ></span>
                            <ReactToolTip id="closedetach" place="top" effect='solid'>close</ReactToolTip>
                            <div className="popup_header">
                                <div className="sub_title">Detach Instance</div>
                            </div>
                            <div className="popup_body">
                                <p>Are you sure you want to detach the instance from the load balancer?</p>
                            </div>
                            <div className="popup_footer">
                                <div className="popup_footer__btns">
                                    <div className="btn btn_confirm" >Detach</div>
                                    <div className="btn btn_cancel" >Cancel</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CommonMessage message={ message } msgType={ msgType } isUserSubscribed={ isUserSubscribed } handler={ () => setMessage('') } />
        </body>


    );
}